import {
    CATEGORY_SEARCH_VALUE,
    EDIT_ITEM_DEATIL,
    EDIT_ITEM_VALUE,
    ENTER_KEY_VAL,
    GET_ALL_AUCTION_GAMES,
    GET_ALL_CATEGORIES,
    GET_ALL_COMPLETED_AUCTIONS,
    GET_ALL_ENDING_AUCTIONS,
    GET_ALL_COMING_SOON_AUCTIONS,
    GET_ALL_FEATURED_AUCTIONS,
    GET_ALL_NEW_AUCTIONS,
    GET_ALL_RESERVED_AUCTIONS,
    GET_ALL_SEARCHED_CATEGORY,
    GET_ALL_SELL_ITEMS,
    GET_ALL_SOLD_ITEMS,
    GET_ALL_USER_BIDS,
    GET_ALL_WATCH_LISTS,
    GET_AUCTION_SEARCH_NAMES,
    GET_CLOSEST_TOTAL,
    GET_CURRENT_BID_AUCTIONS,
    GET_GAME_DETAIL,
    GET_SEARCH_DATA,
    GET_TOTAL_ENDING,
    GO_TO_SELL_ITEM,
    ITEM_SEARCH_VALUE,
    LOST_DATA,
    RESET_TIME,
    USER_DELIVERY_STATUS,
    USER_DISPUTES,
    USER_SAVED_SEARCHES,
    USER_SHIPPING_ADDRESSES,
    FETCH_USER_MANAGED_BIDS_LOADING,
    FETCH_USER_MANAGED_BIDS_SUCCESS,
    FETCH_USER_MANAGED_BIDS_ERROR,
    WS_UPDATE_MY_BID_STATUS_MANAGED,
    WS_USER_WAS_OUTBID_MANAGED,
    WS_TRACKED_AUCTION_ENDED_MANAGED,
    FETCH_USER_WON_AUCTIONS_LOADING,
    FETCH_USER_WON_AUCTIONS_SUCCESS,
    FETCH_USER_WON_AUCTIONS_ERROR,
    FETCH_USER_LISTED_AUCTIONS_LOADING,
    FETCH_USER_LISTED_AUCTIONS_SUCCESS,
    FETCH_USER_LISTED_AUCTIONS_ERROR,
    SET_MANAGED_BIDS_FILTER,
    RESET_MANAGED_BIDS_FILTERS,
    SET_LISTED_AUCTIONS_FILTER,
    RESET_LISTED_AUCTIONS_FILTERS,
    AUCTION_SUBMITED,
    DELETE_AUCTION_SUCCESS,
    UPDATE_LISTED_AUCTION_ITEM,
    UPDATE_SOLD_ITEM,
    UPDATE_MANAGED_BID_ITEM,
    UPDATE_WON_AUCTION_ITEM,
    SET_AUCTION_VIEWS,
    GET_ALL_SELLER_AUCTIONS,
    GET_ALL_MY_AUCTIONS,
    GET_MY_AUCTION_DETAIL,
    GET_ALL_MY_ORDER,
    GET_ALL_MY_SOLDITEM,
    GET_MY_BID_ONGOING,
    GET_HANDLE_HOME_SLIDE,
    GET_HANDLE_FOOTER_NEWSLETTER,
    GET_ON_AUCTION,
    GET_WON_BIDMANAGEMENT,
    GET_LOST_BIDMANAGEMENT,
    GET_ALL_BIDMANAGEMENT,
    GET_ONGOING_BIDMANAGEMENT,
    GET_IS_AUCTION,
    GET_SELLER_DETAIL,
    GET_ALL_NEW_NOTIFICATIONS,
    GET_ALL_SHIPPING_METHOD,
    GET_TRACK_STATUS,
    GET_CATEGORIES,
    GET_BRANDS,
    GET_VARIANTS_PRODUCTS,
    GET_MASTER_PRODUCTS,
    GET_CART_ITEMS,
    GET_SEARCHSUGGESTIONS,
    GET_SEARCHVALUES,
    GET_MY_EDIT_AUCTION_DETAIL,
    GET_SELLER_COUNTRIES_OF_ORIGIN,
    GET_SELLER_GENDERS,
    GET_SELLER_SEASONS,
    GET_SELLER_MATERIALS,
    GET_SELLER_MODELS,
    GET_SELLER_PRODUCT_SUBTYPE,
    GET_PRODUCT_SIZES,
    GET_SEARCH_TOTAL,
    GET_ALL_COUNTRIES,
} from "./auctionTypes";

const initialState = {
    sellerCountriesoforigin: [],
    sellerGender: [],
    sellerSeasons: [],
    productSizes: [],
    sellerMaterials: [],
    sellerModels: [],
    sellerProductType: [],
    allgames: [],
    allAuctions: [],
    searchnames: [],
    auctionDetail: [],
    editAuctionDetail: [],
    bidOnGoing: [],
    homeCrausalHandleData: [],
    footerNewsletterHandleData: [],
    lostData: false,
    searchValue: null,
    categoryValue: null,
    enterKeyVal: false,
    allSellItems: [],
    totalSellItems: 0,
    watchlists: [],
    savesearch: [],
    endingauctions: [],
    totalendings: 0,
    newauctions: [],
    totalnewest: 0,
    comingSoonAuctions: [],
    totalComingSoon: 0,
    reservedauctions: [],
    totalreserved: 0,
    allcategories: [],
    userallbids: [],
    totalallbids: 0,
    gamedetail: [],
    totalsold: 0,
    edititem: null,
    totalcategories: 0,
    allsearchCategories: null,
    editedItem: false,
    gotoSellItem: null,
    resetTime: false,
    completedauctions: [],
    totalcompleted: 0,
    totalClosest: 0,
    allauctionCategories: [],
    featuredauctions: [],
    totalfeatured: 0,
    currentauctions: [],
    totalcurrent: 0,
    savedSearches: [],
    disputes: [],
    disputesTotal: 0,
    addresses: [],
    addressesTotal: 0,
    deliveryStatus: null,
    auctionSubmit: false,
    searchData: [],
    managedBidsList: [],
    managedBidsLoading: false,
    managedBidsError: null,
    managedBidsPagination: {
        totalItems: 0,
        totalPages: 0,
        currentPage: 1,
        limit: 10,
    },
    managedBidsFilters: {
        showLost: true,
        showWon: true,
        showLive: true,
    },
    wonAuctionsList: [],
    wonAuctionsLoadingState: false,
    wonAuctionsErrorState: null,
    wonAuctionsPagination: {
        totalItems: 0,
        totalPages: 0,
        currentPage: 1,
        limit: 10,
    },
    listedAuctionsList: [],
    listedAuctionsLoadingState: false,
    listedAuctionsErrorState: null,
    listedAuctionsPagination: {
        totalItems: 0,
        totalPages: 0,
        currentPage: 1,
        limit: 10,
    },
    orderItem: [],
    totalorders: 0,
    listedAuctionsFilters: {
        showPending: true,
        showLive: true,
        showPast: true,
    },
    itemsListed: [],
    totalitems: 0,
    solditems: [],
    totalsolditem: 0,

    on_auctiondata: [],
    won_bid: [],
    lost_bid: [],
    all_bid: [],
    ongoing_bid: [],
    is_auctiondata: [],
    sellerdetail: [],
    pushNotifications: [],
    allShippingMethods: [],
    trackstatus: [],
    categories: [],
    brandName: [],
    masterProducts: [],
    cartitems: [],
    variants: [],
    allSearchSuggestions: [],
    searchValues: [],
    searchCount: 0,
    allcountriesdata: [],
};

export const auctionReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ALL_AUCTION_GAMES:
            return {
                ...state,
                allgames: action.payload,
            };
        case GET_ALL_SELLER_AUCTIONS:
            return {
                ...state,
                allAuctions: action.payload,
            };
        // case GET_ALL_MY_AUCTIONS:
        //   return {
        //     ...state,
        //     itemsListed: action.payload,
        //   };
        case GET_ALL_MY_AUCTIONS:
            return {
                ...state,
                itemsListed: [...action.payload.data],
                totalitems: Number(action.payload.total_count),
            };

        case GET_MY_AUCTION_DETAIL:
            return {
                ...state,
                auctionDetail: action.payload,
            };
        case GET_MY_EDIT_AUCTION_DETAIL:
            return {
                ...state,
                editAuctionDetail: action.payload,
            };
        case GET_PRODUCT_SIZES:
            return {
                ...state,
                productSizes: action.payload,
            };
        case GET_CATEGORIES:
            return {
                ...state,
                categories: action.payload,
            };
        case GET_BRANDS:
            return {
                ...state,
                brandName: action.payload,
            };
        case GET_SEARCHSUGGESTIONS:
            return {
                ...state,
                allSearchSuggestions: action.payload,
            };
        case GET_SEARCHVALUES:
            return {
                ...state,
                searchValues: action.payload,
            };
        case GET_SEARCH_TOTAL:
            return {
                ...state,
                searchCount: action.payload,
            };
        case GET_VARIANTS_PRODUCTS:
            return {
                ...state,
                variants: action.payload,
            };
        case GET_MASTER_PRODUCTS:
            return {
                ...state,
                masterProducts: action.payload,
            };
        case GET_CART_ITEMS:
            return {
                ...state,
                cartitems: action.payload,
            };
        case GET_ALL_MY_ORDER:
            return {
                ...state,
                orderItem: [...action.payload.data],
                totalorders: Number(action.payload?.length),
            };

        case GET_ALL_MY_SOLDITEM:
            return {
                ...state,
                soldItem: action.payload,
                totalsolditem: Number(action.payload?.length),
            };
        case GET_MY_BID_ONGOING:
            return {
                ...state,
                bidOnGoing: action.payload,
            };
        case GET_HANDLE_HOME_SLIDE:
            return {
                ...state,
                homeCrausalHandleData: action.payload,
            };
        case GET_HANDLE_FOOTER_NEWSLETTER:
            return {
                ...state,
                footerNewsletterHandleData: action.payload,
            };
        case GET_ALL_SHIPPING_METHOD:
            return {
                ...state,
                allShippingMethods: action.payload,
            };

        case GET_AUCTION_SEARCH_NAMES:
            return {
                ...state,
                searchnames: action.payload,
            };

        case ITEM_SEARCH_VALUE:
            return {
                ...state,
                searchValue: action.payload,
            };
        case CATEGORY_SEARCH_VALUE:
            return {
                ...state,
                categoryValue: action.payload,
            };
        case ENTER_KEY_VAL:
            return {
                ...state,
                enterKeyVal: action.payload,
            };
        case GET_ALL_SELL_ITEMS:
            return {
                ...state,
                allSellItems: action.payload.data,
                totalSellItems: action.payload.total,
            };
        case GET_ALL_WATCH_LISTS:
            return {
                ...state,
                watchlists: action.payload,
                savesearch: action.payload.save_search,
            };
        case AUCTION_SUBMITED:
            return {
                ...state,
                auctionSubmit: action.payload,
            };
        case GET_ALL_ENDING_AUCTIONS:
            return {
                ...state,
                endingauctions: action.payload.data,
            };
        case GET_SELLER_DETAIL:
            return {
                ...state,
                sellerdetail: action.payload.data,
            };
        case GET_TRACK_STATUS:
            return {
                ...state,
                trackstatus: action.payload.data,
            };

        case GET_ALL_NEW_NOTIFICATIONS:
            return {
                ...state,
                pushNotifications: [action.payload, ...(state.pushNotifications || [])],
            };
        case GET_ALL_SEARCHED_CATEGORY:
            return {
                ...state,
                allsearchCategories: action.payload
                    ? action.payload
                    : state.allsearchCategories,
            };
        case GET_ALL_NEW_AUCTIONS:
            return {
                ...state,
                newauctions: action.payload.data,
                totalnewest: action.payload.total,
            };
        case GET_ALL_COUNTRIES:
            return {
                ...state,
                allcountriesdata: action.payload,
            };
        case GET_ALL_COMING_SOON_AUCTIONS:
            return {
                ...state,
                comingSoonAuctions: action.payload.data,
                totalComingSoon: action.payload.total,
            };
        case FETCH_USER_MANAGED_BIDS_LOADING:
            return {
                ...state,
                managedBidsLoading: true,
                managedBidsError: null,
            };
        case FETCH_USER_MANAGED_BIDS_SUCCESS:
            return {
                ...state,
                managedBidsLoading: false,
                managedBidsList: action.payload.items || [],
                // totalManagedBids: action.payload.totalItems || 0,
                managedBidsPagination: action.payload.pagination,
                managedBidsError: null,
            };
        case FETCH_USER_MANAGED_BIDS_ERROR:
            return {
                ...state,
                managedBidsLoading: false,
                managedBidsError: action.payload,
                managedBidsList: [],
            };
        case SET_MANAGED_BIDS_FILTER:
            return {
                ...state,
                managedBidsFilters: {
                    ...state.managedBidsFilters,
                    [action.payload.filterName]: action.payload.value,
                },
            };

        case RESET_MANAGED_BIDS_FILTERS:
            return {
                ...state,
                managedBidsFilters: {
                    ...initialState.managedBidsFilters,
                },
            };

        case WS_UPDATE_MY_BID_STATUS_MANAGED: {
            const updatedItem = action.payload;
            const existingItemIndex = state.managedBidsList.findIndex(
                (item) => item.auctionId === updatedItem.auctionId
            );

            let newManagedBidsList;
            if (existingItemIndex > -1) {
                newManagedBidsList = state.managedBidsList.map((item, index) =>
                    index === existingItemIndex
                        ? {
                            ...item,
                            auctionTitle: updatedItem.auctionTitle || item.auctionTitle,
                            myHighestBidAmount: updatedItem.myHighestBidAmount,
                            overallHighestBidAmount: updatedItem.overallHighestBid,
                            status: updatedItem.status,
                            endDate: updatedItem.endDate,
                        }
                        : item
                );
            } else {
                newManagedBidsList = [
                    {
                        auctionId: updatedItem.auctionId,
                        auctionTitle: updatedItem.auctionTitle,
                        myHighestBidAmount: updatedItem.myHighestBidAmount,
                        overallHighestBidAmount: updatedItem.overallHighestBid,
                        status: updatedItem.status,
                        endDate: updatedItem.endDate,
                    },
                    ...state.managedBidsList,
                ];
            }
            return { ...state, managedBidsList: newManagedBidsList };
        }

        case WS_USER_WAS_OUTBID_MANAGED: {
            const outbidUpdate = action.payload;
            return {
                ...state,
                managedBidsList: state.managedBidsList.map((item) =>
                    item.auctionId === outbidUpdate.auctionId
                        ? {
                            ...item,
                            overallHighestBidAmount: outbidUpdate.overallHighestBid,
                            status: "outbid",
                            latest_bid_by: outbidUpdate.outBidById,
                            endDate: outbidUpdate.endDate,
                        }
                        : item
                ),
            };
        }

        case WS_TRACKED_AUCTION_ENDED_MANAGED: {
            const endedUpdate = action.payload;
            return {
                ...state,
                managedBidsList: state.managedBidsList.map((item) =>
                    item.auctionId === endedUpdate.auctionId
                        ? {
                            ...item,
                            status: endedUpdate.status,
                            overallHighestBid:
                                endedUpdate.winningBidAmount || item.overallHighestBid,
                        }
                        : item
                ),
            };
        }
        case GET_ALL_RESERVED_AUCTIONS:
            return {
                ...state,
                reservedauctions: action.payload.data,
                totalreserved: action.payload.total,
            };
        case GET_ALL_CATEGORIES:
            return {
                ...state,
                allcategories: action.payload.data.filter(
                    (item) => item?.is_feature === true
                ),
                allauctionCategories: [
                    ...state.allauctionCategories, // Keep existing categories
                    ...(action.payload.data || []), // Append new categories
                ],
                totalcategories: action.payload.total,
            };
        case GET_GAME_DETAIL:
            return {
                ...state,
                gamedetail: action.payload,
            };
        case GET_ALL_USER_BIDS:
            return {
                ...state,
                userallbids: action.payload.data,
                totalallbids: action.payload.total,
            };
        case GET_ALL_SOLD_ITEMS:
            return {
                ...state,
                solditems: action.payload.data,
                totalsold: action.payload.total,
            };
        case EDIT_ITEM_DEATIL:
            return {
                ...state,
                edititem: action.payload,
            };
        case EDIT_ITEM_VALUE:
            return {
                ...state,
                editedItem: action.payload,
            };
        case GO_TO_SELL_ITEM:
            return {
                ...state,
                gotoSellItem: action.payload,
            };
        case RESET_TIME:
            return {
                ...state,
                resetTime: action.payload,
            };
        case GET_ALL_COMPLETED_AUCTIONS:
            return {
                ...state,
                completedauctions: action.payload.data,
                totalcompleted: action.payload.total,
            };
        case GET_TOTAL_ENDING:
            return {
                ...state,
                totalendings: action.payload,
            };
        case GET_CLOSEST_TOTAL:
            return {
                ...state,
                totalClosest: action.payload,
            };

        case GET_ALL_FEATURED_AUCTIONS:
            return {
                ...state,
                featuredauctions: action.payload.data,
                totalfeatured: action.payload.total,
            };
        case LOST_DATA:
            return {
                ...state,
                lostData: action.payload,
            };
        case GET_CURRENT_BID_AUCTIONS:
            return {
                ...state,
                currentauctions: action.payload.data,
                totalcurrent: action.payload.total,
            };
        case USER_SAVED_SEARCHES:
            return {
                ...state,
                savedSearches: action.payload,
            };
        case GET_ON_AUCTION:
            return {
                ...state,
                on_auctiondata: action.payload,
            };
        case USER_DISPUTES:
            return {
                ...state,
                disputes: action.payload.data,
                disputesTotal: action.payload.total,
            };
        case USER_SHIPPING_ADDRESSES:
            return {
                ...state,
                addresses: action.payload.list,
                addressesTotal: action.payload?.total || 0,
            };
        case USER_DELIVERY_STATUS:
            return {
                ...state,
                deliveryStatus: action.payload,
            };
        case GET_SEARCH_DATA:
            return {
                ...state,
                searchData: action.payload,
            };

        case GET_WON_BIDMANAGEMENT:
            return {
                ...state,
                won_bid: action.payload,
            };

        case GET_LOST_BIDMANAGEMENT:
            return {
                ...state,
                lost_bid: action.payload,
            };

        case GET_ALL_BIDMANAGEMENT:
            return {
                ...state,
                all_bid: action.payload,
            };
        case GET_ONGOING_BIDMANAGEMENT:
            return {
                ...state,
                ongoing_bid: action.payload,
            };
        case GET_IS_AUCTION:
            return {
                ...state,
                is_auctiondata: action.payload,
            };

        case FETCH_USER_WON_AUCTIONS_LOADING:
            return {
                ...state,
                wonAuctionsLoadingState: true,
                wonAuctionsErrorState: null,
            };
        case FETCH_USER_WON_AUCTIONS_SUCCESS:
            return {
                ...state,
                wonAuctionsLoadingState: false,
                wonAuctionsList: action.payload.items || [],
                wonAuctionsPagination: action.payload.pagination,
                wonAuctionsErrorState: null,
            };
        case FETCH_USER_WON_AUCTIONS_ERROR:
            return {
                ...state,
                wonAuctionsLoadingState: false,
                wonAuctionsErrorState: action.payload,
                wonAuctions: [],
                wonAuctionsPagination: {
                    ...initialState.wonAuctionsPagination,
                    limit: state.wonAuctionsPagination.limit,
                },
            };
        case FETCH_USER_LISTED_AUCTIONS_LOADING:
            return {
                ...state,
                listedAuctionsLoadingState: true,
                listedAuctionsErrorState: null,
            };
        case FETCH_USER_LISTED_AUCTIONS_SUCCESS:
            // console.log('REDUCER ACTION PAYLOAD:', action.payload)
            return {
                ...state,
                listedAuctionsLoadingState: false,
                listedAuctionsList: action.payload.items || [],
                listedAuctionsPagination: action.payload.pagination,
                listedAuctionsErrorState: null,
            };

        case DELETE_AUCTION_SUCCESS:
            const deletedItemId = action.payload;

            return {
                ...state,
                listedAuctionsList: state.listedAuctionsList.filter(
                    (item) => item._id !== deletedItemId
                ),

                newauctions: state.newauctions.filter(
                    (item) => item._id !== deletedItemId
                ),
                endingsoon: state.endingauctions.filter(
                    (item) => item._id !== deletedItemId
                ),
                comingSoonAuctions: state.comingSoonAuctions.filter(
                    (item) => item._id !== deletedItemId
                ),
                featuredauctions: state.featuredauctions.filter(
                    (item) => item._id !== deletedItemId
                ),
            };

        case FETCH_USER_LISTED_AUCTIONS_ERROR:
            return {
                ...state,
                listedAuctionsLoadingState: false,
                listedAuctionsErrorState: action.payload,
                listedAuctions: [],
                listedAuctionsPagination: {
                    ...initialState.listedAuctionsPagination,
                    limit: state.listedAuctionsPagination.limit,
                },
            };
        case SET_LISTED_AUCTIONS_FILTER:
            return {
                ...state,
                listedAuctionsFilters: {
                    ...state.listedAuctionsFilters,
                    [action.payload.filterName]: action.payload.value,
                },
            };

        case RESET_LISTED_AUCTIONS_FILTERS:
            return {
                ...state,
                listedAuctionsFilters: {
                    ...initialState.listedAuctionsFilters,
                },
            };

        case UPDATE_LISTED_AUCTION_ITEM: {
            const updatedItem = action.payload;
            return {
                ...state,
                listedAuctionsList: state.listedAuctionsList.map((item) =>
                    item._id === updatedItem._id ? updatedItem : item
                ),
            };
        }

        case UPDATE_SOLD_ITEM: {
            const updatedItem = action.payload;
            console.log("UPDATE_MANAGED_BID_ITEM");

            return {
                ...state,
                solditems: state.solditems.map((item) =>
                    item._id === updatedItem._id ? updatedItem : item
                ),
            };
        }

        case UPDATE_MANAGED_BID_ITEM: {
            const updatedItem = action.payload;
            console.log("UPDATE_MANAGED_BID_ITEM");
            return {
                ...state,
                managedBidsList: state.managedBidsList.map((item) => {
                    if (item.auctionId === updatedItem._id) {
                        return {
                            ...item,
                            rated_by: updatedItem.rated_by,
                            address: updatedItem.address,
                            status: updatedItem.auctionProcessStatus,
                        };
                    }
                    return item;
                }),
            };
        }

        case UPDATE_WON_AUCTION_ITEM: {
            const updatedItem = action.payload;
            return {
                ...state,
                wonAuctionsList: state.wonAuctionsList.map((item) => {
                    if (item.auctionId === updatedItem._id) {
                        return {
                            ...item,
                            rated_by: updatedItem.rated_by,
                            address: updatedItem.address,
                            status: updatedItem.auctionProcessStatus,
                        };
                    }
                    return item;
                }),
            };
        }

        case GET_SELLER_COUNTRIES_OF_ORIGIN:
            return {
                ...state,
                sellerCountriesoforigin: action.payload,
            };

        case GET_SELLER_GENDERS:
            return {
                ...state,
                sellerGender: action.payload,
            };

        case GET_SELLER_MATERIALS:
            return {
                ...state,
                sellerMaterials: action.payload,
            };

        case GET_SELLER_MODELS:
            return {
                ...state,
                sellerModels: action.payload,
            };

        case GET_SELLER_PRODUCT_SUBTYPE:
            return {
                ...state,
                sellerProductType: action.payload,
            };

        case GET_SELLER_SEASONS:
            return {
                ...state,
                sellerSeasons: action.payload,
            };

        default:
            return state;
    }
};
